import { render, staticRenderFns } from "./Usuarios_aliados.vue?vue&type=template&id=38166230&scoped=true&"
import script from "./Usuarios_aliados.vue?vue&type=script&lang=ts&"
export * from "./Usuarios_aliados.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38166230",
  null
  
)

export default component.exports